export interface OnboardingWelcomeCta {
  label: string;
  destination: string; // Route path or URL
  trackingId: string; // For analytics
}

export interface OnboardingWelcomeFeatureList {
  title: string;
  items: string[];
}

export interface OnboardingWelcomeConfig {
  title: string;
  subtitle: string; // Supports {daysRemaining} and {trialEndDate} placeholders
  description: string;
  primaryCta: OnboardingWelcomeCta;
  secondaryCta: OnboardingWelcomeCta;
  featureList: OnboardingWelcomeFeatureList;
}

// Default config used as fallback
export const DEFAULT_ONBOARDING_WELCOME_CONFIG: OnboardingWelcomeConfig = {
  title: 'Welcome to JotPsych',
  subtitle: 'You have full access for the next {daysRemaining} days, until {trialEndDate}.',
  description: "After the trial, you'll choose a plan — we'll remind you before it ends.",
  primaryCta: {
    label: 'Record your first encounter',
    destination: '/encounters/active',
    trackingId: 'record_first_encounter',
  },
  secondaryCta: {
    label: 'Take me to the home page',
    destination: '/',
    trackingId: 'go_to_home',
  },
  featureList: {
    title: 'What you can try during your trial:',
    items: [
      'Creating clinical notes',
      'AI Editor',
      'Clinical documents & assessments',
      'Lab orders',
      'Payer aware notes',
    ],
  },
};
